import { Model as o } from "../../../model.js";
class r extends o {
  constructor(t, c) {
    super(), this.loyalty = t;
  }
}
export {
  r as ActivityModel
};
//# sourceMappingURL=activity.model.js.map
